module.exports = __webpack_public_path__ + "static/media/aaha_timi_le.7cebc6f7.ogg";